
import { User } from './types';

export const defaultUsers: User[] = [
  {
    id: 'user-joe',
    username: 'Joe',
    name: 'Joe',
    password: btoa('0000'), // MDAwMA==
    avatar: '🐶'
  },
  {
    id: 'user-evancy',
    username: 'Evancy',
    name: 'Evancy',
    password: btoa('0000'),
    avatar: '🐷'
  },
  {
    id: 'user-jenny',
    username: 'Jenny',
    name: 'Jenny',
    password: btoa('0000'),
    avatar: '🐑'
  },
  {
    id: 'user-cindy',
    username: 'Cindy',
    name: 'Cindy',
    password: btoa('0000'),
    avatar: '🐔'
  }
];
